import { Box, TextField } from '@mui/material';
import { UseFormRegister, Controller, Control } from 'react-hook-form';
import { colors } from 'Constants/Colors';

interface Props {
  register: UseFormRegister<any>;
  control: Control<any>;
  name: string;
  error?: any;
  currentValue?: string;
}

const QuestionnaireFreeResponse = ({ control, name, error, currentValue }: Props) => {
  return (
    <Box
      sx={{
        flex: 1,
        mt: 2,
      }}
    >
      <Controller
        name={name}
        control={control}
        defaultValue={currentValue || ''}
        render={({ field }) => (
          <TextField
            {...field}
            label="Respuesta"
            multiline
            rows={4}
            fullWidth
            error={!!error}
            helperText={error?.message}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                transition: 'all 0.2s',
                '&:hover': {
                  '& > fieldset': {
                    borderColor: colors.GREEN,
                  },
                },
                '&.Mui-focused': {
                  '& > fieldset': {
                    borderColor: colors.GREEN,
                    borderWidth: '2px',
                  },
                },
              },
              '& .MuiInputLabel-root': {
                '&.Mui-focused': {
                  color: colors.GREEN,
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
};

export default QuestionnaireFreeResponse;
